import { Button, Input, Upload } from "../../../ui";

export default function FoodImageModal({
  imageFile,
  setImageFile,
  imagePreview,
  setImagePreview,
  onSave,
  onCancel,
}) {
  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  };
  return (
    <div className="food-image-modal">
      <div className="food-image-modal-box">
        <h2>ارفع صورة بأبعاد 1024 × 700:</h2>
        <div>
          {imagePreview && (
            <img
              src={imagePreview}
              alt="Preview"
              className="food-image-modal-image-preview"
            />
          )}
        </div>
        <div>
          <Input
            id="food-image-upload"
            type="file"
            accept="image/jpeg,image/jpg,image/png"
            onChange={handleImageChange}
            style={{ display: "none" }}
          />

          <Button
            type="button"
            variant="primary"
            appearance="soft"
            icon={<Upload size={18} />}
            style={{ marginTop: "14px" }}
            onClick={() =>
              document.getElementById("food-image-upload")?.click()
            }
          >
            اختيار صورة
          </Button>
        </div>

        <div className="food-image-modal-actions">
          <Button
            type="button"
            variant="primary"
            appearance="filled"
            fullWidth
            onClick={onSave}
            disabled={!imageFile}
          >
            موافق
          </Button>

          <Button
            type="button"
            variant="warning"
            appearance="soft"
            fullWidth
            onClick={onCancel}
          >
            إلغاء الأمر
          </Button>
        </div>
      </div>
    </div>
  );
}
